/* Warenkorb als Seitenleiste (Redesign), zeigt den echten Shopify-Warenkorb. Kasse = Shopify-Checkout.
   Im Craft-Theme: liegt in der .zyx-Ebene (Redesign-CSS), ersetzt den Craft-Warenkorb (Symbol im Header, Craft-Kaufknöpfe, Buyboxen). */
(function () {
  const D = window.ZY, S = window.ZYStore, site = window.ZYSite;
  const eur = D.eur;
  const R = Object.assign({ root: '/' }, D.routes);
  let root, body, foot, countEl, lastFocus = null, prevUnlocked = null, highlight = [], isOpen = false, busy = false;

  const byVariant = id => D.scents.find(s => s.variant === id);
  const pfByVariant = id => D.perfumes.find(p => p.variant === id);
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const money = c => eur((c || 0) / 100);
  const MAX = () => (D.thresholds.length ? D.thresholds[D.thresholds.length - 1].amount : 0);
  // Anteil der Rabattcodes auf Bestellebene am Warenkorb (0,3 bei AROMA30). Shopify verteilt sie im Checkout anteilig auf die Artikel;
  // wir zeigen Zeilen, Duft-Vorschlag und „Passt dazu“ schon hier mit diesem Anteil reduziert.
  let codeRate = 0, codeTitles = [];
  const withCode = cents => Math.round(cents * (1 - codeRate));
  function updateCodeRate(state) {
    const apps = (state.cart_level_discount_applications || []).filter(d => d.type === 'discount_code' && d.total_allocated_amount > 0);
    const base = state.items.reduce((a, i) => a + i.final_line_price, 0);
    const off = apps.reduce((a, d) => a + d.total_allocated_amount, 0);
    codeRate = base > 0 ? Math.min(off / base, 1) : 0;
    codeTitles = apps.map(d => d.title).filter(Boolean);
  }

  function mount() {
    root = document.createElement('div');
    root.className = 'cart';
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML = `
      <div class="cart__scrim" data-cart-close></div>
      <aside class="cart__panel" role="dialog" aria-modal="true" aria-labelledby="cartTitle">
        <div class="cart__head">
          <h2 id="cartTitle">Warenkorb<span data-n></span></h2>
          <button class="icon-btn" type="button" data-cart-close aria-label="Warenkorb schließen"><i class="ph-light ph-x" aria-hidden="true"></i></button>
        </div>
        <div class="cart__body" data-lenis-prevent></div>
        <div class="cart__foot"></div>
      </aside>`;
    // Warenkorb-Seite (/cart): derselbe Warenkorb, fest in der Seite statt als Seitenleiste
    const pageSlot = document.querySelector('[data-zy-cart-page]');
    if (pageSlot) {
      root.classList.add('cart--page', 'is-open');
      root.setAttribute('aria-hidden', 'false');
      root.querySelector('.cart__panel').removeAttribute('aria-modal');
      root.querySelector('.cart__panel').setAttribute('role', 'region');
      pageSlot.appendChild(root);
      isOpen = true;
    } else {
      // In der .zyx-Ebene, damit das Redesign-CSS greift (Craft-Seiten haben sonst keinen .zyx-Rahmen)
      (document.querySelector('.zyx-layer') || document.body).appendChild(root);
    }
    body = root.querySelector('.cart__body');
    foot = root.querySelector('.cart__foot');
    countEl = root.querySelector('[data-n]');
    root.addEventListener('click', onClick);
    root.addEventListener('change', e => {
      const sel = e.target.closest('[data-gift-swap]');
      if (sel) run(() => S.swapGift(sel.dataset.giftSwap, Number(sel.dataset.product), Number(sel.value)), 'Geschenk geändert');
    });
    // Rabattcode einlösen: zu den bereits eingelösten Codes hinzufügen, Shopify prüft die Gültigkeit
    root.addEventListener('submit', e => {
      const f = e.target.closest('[data-code-form]');
      if (!f) return;
      e.preventDefault();
      const code = f.code.value.trim();
      if (!code) return;
      const current = (S.state.discount_codes || []).map(c => c.code);
      if (current.some(c => c.toLowerCase() === code.toLowerCase())) { site.toast('Dieser Code ist schon eingelöst.'); return; }
      run(async () => {
        const res = await S.setCodes(current.concat(code));
        const hit = res.find(c => c.code.toLowerCase() === code.toLowerCase());
        site.toast(hit && hit.applicable ? 'Rabattcode eingelöst' : 'Dieser Code gilt nicht für deinen Warenkorb.');
      });
    });
    root.addEventListener('keydown', trapFocus);
    // Warenkorb-Symbol im Craft-Header: vor Craft abfangen (Capture), damit sich nicht der Craft-Warenkorb öffnet
    document.addEventListener('click', e => {
      if (!e.target.closest('[data-cart-open], #cart-icon-bubble')) return;
      if (isPage()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
    }, true);
    // Craft-Kaufknöpfe öffnen den Craft-Warenkorb: sofort schließen und stattdessen diesen öffnen
    const craftDrawer = document.querySelector('cart-drawer');
    if (craftDrawer) {
      new MutationObserver(() => {
        if (!craftDrawer.classList.contains('active')) return;
        if (typeof craftDrawer.close === 'function') craftDrawer.close();
        document.body.classList.remove('overflow-hidden');
        S.refresh({ added: [] }).then(() => open());
      }).observe(craftDrawer, { attributes: true, attributeFilter: ['class'] });
    }
    // Buyboxen und andere Skripte können den Warenkorb über ein Ereignis öffnen lassen
    document.addEventListener('zy:cart-open', () => S.refresh().then(() => open()));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && isOpen) close(); });
    S.subscribe(render);
    S.subscribe(syncCraftBubble);
  }

  // Artikelzahl am Warenkorb-Symbol im Craft-Header aktuell halten
  function syncCraftBubble(state) {
    const icon = document.getElementById('cart-icon-bubble');
    if (!icon || !state.token) return; // Platzhalter vor dem ersten Laden nicht anzeigen
    const n = state.item_count || 0;
    let bubble = icon.querySelector('.cart-count-bubble');
    if (!n) { if (bubble) bubble.remove(); return; }
    if (!bubble) { bubble = document.createElement('div'); bubble.className = 'cart-count-bubble'; icon.appendChild(bubble); }
    bubble.innerHTML = `<span aria-hidden="true">${n}</span><span class="visually-hidden">${n} Artikel</span>`;
  }

  const isPage = () => root.classList.contains('cart--page');

  function open(opts) {
    opts = opts || {};
    if (isPage()) { highlight = opts.highlight || []; render(S.state, S.totals(), {}); root.scrollIntoView({ behavior: site.reduce ? 'auto' : 'smooth' }); return; }
    highlight = opts.highlight || [];
    if (!isOpen) lastFocus = document.activeElement;
    isOpen = true;
    render(S.state, S.totals(), { opening: true });
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (site.lenis) site.lenis.stop();
    setTimeout(() => { const b = root.querySelector('[data-cart-close].icon-btn'); if (b) b.focus({ preventScroll: true }); }, 60);
  }

  function close() {
    if (isPage()) return;
    isOpen = false;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (site.lenis) site.lenis.start();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function trapFocus(e) {
    if (e.key !== 'Tab' || !isOpen || isPage()) return;
    const f = root.querySelectorAll('.cart__panel button, .cart__panel a, .cart__panel select, .cart__panel input');
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Rendering ---------- */
  const markLabel = { shipping: 'Versand', oil: 'Öl', diffuser: 'Raumduft' };
  const nextText = { shipping: 'zum kostenlosen Versand', oil: 'zu deinem Gratis-Öl', diffuser: 'zum Gratis-Raumduft' };
  const doneText = { shipping: 'Der Versand ist gratis.', oil: 'Dein ätherisches Öl ist gratis dabei.', diffuser: 'Ein Raumduft ist gratis dabei.' };

  function progressHTML(t, justSet) {
    if (!D.thresholds.length) return '';
    const m = t.total, max = MAX();
    const done = t.unlocked.length ? doneText[t.unlocked[t.unlocked.length - 1].key] + ' ' : '';
    const msg = t.next ? `${done}Noch <b>${eur(t.next.amount - m)}</b> bis ${nextText[t.next.key]}.` : 'Alles freigeschaltet: ' + D.thresholds.map(x => x.label).join(', ') + '.';
    return `
      <div class="progress">
        <p class="progress__msg" aria-live="polite">${msg}</p>
        <div class="progress__bar">
          <div class="progress__fill" style="transform:scaleX(${Math.min(m / max, 1)})"></div>
          ${D.thresholds.map(th => `<div class="progress__mark${m >= th.amount ? ' is-on' : ''}${justSet.has(th.key) ? ' just' : ''}" style="left:${(th.amount / max) * 100}%" title="${th.label} ab ${eur(th.amount)}">
              <i class="ph-light ${th.icon}" aria-hidden="true"></i><span>${markLabel[th.key]} ab ${th.amount} €</span></div>`).join('')}
        </div>
      </div>`;
  }

  // Geschenk-Produkte aus dem Geschenk-Schutz (0 €, Sorte wählbar)
  const giftInfo = item => {
    const G = window.ZYD_GIFTS;
    if (!G) return null;
    if (item.product_id === G.oil.product) return Object.assign({ key: 'oil' }, G.oil);
    if (item.product_id === G.room.product) return Object.assign({ key: 'room' }, G.room);
    return null;
  };

  function thumbFor(item) {
    const g = giftInfo(item);
    const oilImg = ((window.ZYX_VD || {}).oilImages || {})[item.variant_title];
    if (g && g.key === 'oil') return oilImg || D.img('pack-oil', 300);
    if (g && g.key === 'room') { const sc = D.scents.find(x => x.name === item.variant_title); if (sc) return D.img('pack-' + sc.id, 240); }
    const s = byVariant(item.variant_id);
    if (s) return D.img('pack-' + s.id, 240);
    const p = pfByVariant(item.variant_id);
    if (p) return D.img('pf-' + p.id, 240);
    // Refill, Kerze, Öl: Bild der gewählten Sorte (Variantenbild aus Shopify bzw. Öl-Produktfoto)
    for (const k of ['refill', 'candle', 'oil']) {
      const pr = D.products[k];
      const v = pr.vmap && Object.values(pr.vmap).find(x => x.id === item.variant_id);
      if (v) return (k === 'oil' && oilImg) || v.img || (item.image && item.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2')) || D.img(pr.img, 300);
    }
    if (item.image) return item.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2');
    return '';
  }

  function upsellHTML(t) {
    const u = t.upsell;
    if (!u) return '';
    // Alle Düfte zur Wahl, auch die schon im Warenkorb (manche wollen denselben Duft zweimal); vorausgewählt ist ein neuer
    const opts = D.scents
      .map(s => `<option value="${s.id}"${s.id === u.scent ? ' selected' : ''}${s.soldOut ? ' disabled' : ''}>${s.name}${s.soldOut ? ' (ausverkauft)' : ''}</option>`).join('');
    const delta = withCode(u.delta * 100) / 100;
    const price = u.from === 1 ? `<b>nur ${eur(delta)}</b> statt ${eur(D.single)}` : `<b>nur ${eur(delta)} mehr</b>`;
    return `
      <div class="upsell">
        <p>Nimm einen ${u.to}. Duft dazu: ${price}.</p>
        <div class="upsell__row">
          <label class="sr-only" for="up-scent">Duft wählen</label>
          <select class="zy-select" id="up-scent" data-upsell-scent>${opts}</select>
          <button class="btn btn--light btn--sm" type="button" data-upsell>Hinzufügen</button>
        </div>
      </div>`;
  }

  function lineHTML(item, t, isLastRoom) {
    const s = byVariant(item.variant_id);
    const gift = item.final_line_price === 0 && item.original_line_price === 0;
    const gi = giftInfo(item);
    if (gi) return giftLineHTML(item, gi);
    const title = s ? 'Raumduft 150 ml' : item.product_title;
    const variant = item.variant_title && !/default/i.test(item.variant_title) ? item.variant_title : '';
    const chip = s ? `<div class="line__chips"><span><i class="zy-swatch" style="--c:${s.label}"></i>${esc(s.name)}</span></div>` : '';
    const discounts = (item.line_level_discount_allocations || []).filter(a => a.amount > 0)
      .map(a => esc(a.discount_application && a.discount_application.title)).filter(Boolean);
    // Rabattcode auf Bestellebene (z. B. AROMA30) anteilig auf die Zeile verteilen, damit der Preis direkt reduziert wirkt
    const linePrice = withCode(item.final_line_price);
    if (codeRate > 0) discounts.push(...codeTitles.map(esc));
    const compare = item.original_line_price > linePrice ? item.original_line_price : 0;
    return `
      <li class="line${highlight.includes(item.key) ? ' is-new' : ''}${gift ? ' line--gift' : ''}">
        <div class="line__thumb line__thumb--single"><div class="zy-media"><img src="${thumbFor(item)}" alt="" loading="lazy"></div></div>
        <div>
          <div class="line__title">${esc(title)}</div>
          <div class="line__meta">${gift ? 'Geschenk' : s ? '150 ml' : esc(variant)}${discounts.length ? ' · ' + discounts.join(', ') : ''}</div>
          ${chip}
          ${gift ? '' : `<div class="line__ctrl">
            <div class="qty" role="group" aria-label="Menge">
              <button type="button" data-qty="${item.key}" data-to="${item.quantity - 1}" aria-label="Weniger"><i class="ph-light ph-minus" aria-hidden="true"></i></button>
              <span>${item.quantity}</span>
              <button type="button" data-qty="${item.key}" data-to="${item.quantity + 1}" aria-label="Mehr"><i class="ph-light ph-plus" aria-hidden="true"></i></button>
            </div>
            <button class="text-btn" type="button" data-remove="${item.key}">Entfernen</button>
          </div>`}
        </div>
        <div class="line__price num">
          <span>${gift ? '0,00&nbsp;€' : money(linePrice)}</span>
          ${compare ? `<s>${money(compare)}</s>` : ''}
        </div>
        ${isLastRoom ? upsellHTML(t) : ''}
      </li>`;
  }

  function giftLineHTML(item, g) {
    const name = g.key === 'oil' ? 'Ätherisches Öl 10 ml' : 'Raumduft 150 ml';
    const opts = g.variants.map(v => `<option value="${v.id}"${v.id === item.variant_id ? ' selected' : ''}>${esc(v.title)}</option>`).join('');
    const value = g.key === 'oil' ? (D.products.oil.prices[item.variant_title] || 5.95) : D.single;
    return `
      <li class="line line--gift${highlight.includes(item.key) ? ' is-new' : ''}">
        <div class="line__thumb line__thumb--single"><div class="zy-media"><img src="${thumbFor(item)}" alt="" loading="lazy"></div></div>
        <div>
          <div class="line__title">${name}</div>
          <div class="line__meta">Gratis dabei. Wähle deine Sorte:</div>
          <div class="line__ctrl">
            <label class="sr-only" for="g-${item.key}">Sorte für dein Geschenk</label>
            <select class="zy-select" id="g-${item.key}" data-gift-swap="${item.key}" data-product="${g.product}">${opts}</select>
          </div>
        </div>
        <div class="line__price num"><span>0,00&nbsp;€</span><s>${eur(value)}</s></div>
      </li>`;
  }

  function xsellHTML(state) {
    const inCart = new Set(state.items.map(i => i.product_id));
    const cartVariants = new Set(state.items.map(i => i.variant_id));
    const has = k => { const p = D.products[k]; return p.vmap && Object.values(p.vmap).some(v => cartVariants.has(v.id)); };
    const firstRefill = (() => {
      for (const i of state.items) { const s = byVariant(i.variant_id); if (s && D.products.refill.variants.includes(s.name)) return s.name; }
      return D.products.refill.variants[0];
    })();
    const idPf = D.perfumes[0];
    const items = [
      !has('refill') && D.products.refill.variants.length && { id: D.variantOf('refill', firstRefill), name: D.products.refill.name, sub: firstRefill, price: D.products.refill.price, img: D.products.refill.img, src: ((D.products.refill.vmap || {})[firstRefill] || {}).img },
      !has('oil') && D.products.oil.variants.length && { id: D.variantOf('oil', 'Lavendel'), name: D.products.oil.name, sub: 'Lavendel, 10 ml', price: D.products.oil.prices.Lavendel, img: D.products.oil.img, src: ((window.ZYX_VD || {}).oilImages || {}).Lavendel },
      idPf && idPf.available && !cartVariants.has(idPf.variant) && { id: idPf.variant, name: idPf.name, sub: 'Neuroparfum, 50 ml', price: D.perfume.single, img: 'pf-' + idPf.id },
      !has('candle') && D.products.candle.variants.length && { id: D.variantOf('candle', 'Lule'), name: D.products.candle.name, sub: 'Lule, 530 ml', price: D.products.candle.price, img: D.products.candle.img }
    ].filter(x => x && x.id);
    if (!items.length) return '';
    return `
      <div class="xsell">
        <h3>Passt dazu</h3>
        <div class="xsell__nav">
          <button type="button" data-xsell-dir="-1" aria-label="Zurück"><i class="ph-light ph-caret-left" aria-hidden="true"></i></button>
          <button type="button" data-xsell-dir="1" aria-label="Weiter"><i class="ph-light ph-caret-right" aria-hidden="true"></i></button>
        </div>
        <div class="xsell__track">
          ${items.map(x => `<div class="xcard">
              <div class="zy-media"><img src="${x.src || D.img(x.img, 300)}" alt="" loading="lazy"></div>
              <div><strong>${esc(x.name)}</strong><small>${esc(x.sub)}</small></div>
              <div class="xcard__foot"><span class="num">${eur(withCode((x.price || 0) * 100) / 100)}${codeRate > 0 ? ` <s>${eur(x.price || 0)}</s>` : ''}</span>
                <button class="card__add" type="button" data-xadd="${x.id}" aria-label="${esc(x.name)} hinzufügen"><i class="ph-light ph-plus" aria-hidden="true"></i></button></div>
            </div>`).join('')}
        </div>
      </div>`;
  }

  function emptyHTML() {
    const set = D.sets[0];
    const t3 = D.tier(3);
    return `
      <div class="cart-empty">
        <p class="display-s">Dein Warenkorb ist noch leer.</p>
        <p class="muted" style="margin:0">Unser beliebtestes Einstiegs-Set: drei Düfte für den Abend.</p>
        <div class="cart-empty__set">
          <div class="zy-media"><img src="${D.img(set.img, 700)}" alt="Set ${set.name}" loading="lazy"></div>
          <div>
            <strong>${set.name}</strong>
            <p class="muted small" style="margin:4px 0 12px">${set.scents.map(id => D.scent(id).name).join(', ')}</p>
            <button class="btn btn--light btn--sm" type="button" data-add-set="${set.id}">Für ${eur(t3.price)} hinzufügen</button>
          </div>
        </div>
        <a class="zy-link" href="${esc((D.scents[0] || {}).url || R.root)}">Alle Düfte ansehen</a>
      </div>`;
  }

  // Rabattcode-Betrag: Rabatte vom Typ „discount_code“ auf Warenkorb- und Zeilenebene
  const codeCentsOf = state => (state.cart_level_discount_applications || []).filter(d => d.type === 'discount_code').reduce((a, d) => a + (d.total_allocated_amount || 0), 0) +
    state.items.reduce((a, i) => a + (i.line_level_discount_allocations || []).filter(x => x.discount_application && x.discount_application.type === 'discount_code').reduce((b, x) => b + x.amount, 0), 0);

  // Aufschlüsselung (Zwischensumme, Ersparnis, Versand) am Ende der Liste, zum Weiterscrollen
  function summaryHTML(state, t) {
    const giftValue = state.items.reduce((a, i) => {
      const g = giftInfo(i);
      if (!g) return a;
      return a + (g.key === 'oil' ? (D.products.oil.prices[i.variant_title] || 5.95) : D.single) * i.quantity;
    }, 0);
    const saved = Math.round((t.savings + giftValue) * 100) / 100;
    const codeCents = codeCentsOf(state);
    return `
      <div class="sum num cart__summary">
        <div><span>Zwischensumme</span><span>${money(state.original_total_price)}</span></div>
        ${saved > 0 ? `<div class="save"><span>Du sparst${giftValue ? ' inkl. Geschenken' : ''}</span><span>${eur(saved)}</span></div>` : ''}
        ${codeCents > 0 ? `<div class="save"><span>Rabattcode</span><span>−${money(codeCents)}</span></div>` : ''}
        <div><span>Versand</span><span>${t.shipping === 0 ? 'Gratis' : 'Wird im Checkout berechnet'}</span></div>
      </div>`;
  }

  // Fester Fuß wie im Live-Shop, möglichst flach: Summe, Rabattcode-Feld, Zur Kasse, Zahlungsarten
  function footHTML(state) {
    const pay = ['klarna', 'paypal', 'applepay', 'visa', 'mastercard'];
    const codes = state.discount_codes || [];
    return `
      <div class="sum num cart__total"><div class="total"><span>Gesamt <small>inkl. MwSt.</small></span><span>${money(state.total_price)}</span></div></div>
      <form class="zyx-code__form" data-code-form>
        <input type="text" name="code" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="Rabattcode" aria-label="Rabattcode">
        <button class="btn btn--ghost btn--sm" type="submit">Einlösen</button>
      </form>
      ${codes.length ? `<ul class="zyx-code__list">${codes.map(c => `<li class="${c.applicable ? '' : 'is-off'}"><span><i class="ph-light ph-tag" aria-hidden="true"></i>${esc(c.code)}</span>${c.applicable ? '' : '<small>gilt nicht für diesen Warenkorb</small>'}<button type="button" data-code-remove="${esc(c.code)}" aria-label="Code ${esc(c.code)} entfernen"><i class="ph-light ph-x" aria-hidden="true"></i></button></li>`).join('')}</ul>` : ''}
      <a class="btn btn--light btn--block" href="${R.root.replace(/\/$/, '')}/checkout">Zur Kasse<i class="ph-light ph-arrow-right" aria-hidden="true"></i></a>
      <div class="cart__pay" aria-label="Zahlungsarten">${pay.map(p => `<img src="${D.asset('icon-' + p + '.svg')}" alt="${p}" width="20" height="20">`).join('')}</div>`;
  }

  function render(state, t, meta) {
    if (!root) return;
    meta = meta || {};
    countEl.textContent = state.item_count ? ` ${state.item_count} Artikel` : '';
    updateCodeRate(state);
    const unlockedKeys = t.unlocked.map(u => u.key);
    const justSet = new Set();
    if (prevUnlocked && !meta.initial) unlockedKeys.forEach(k => { if (!prevUnlocked.includes(k)) justSet.add(k); });
    prevUnlocked = unlockedKeys;
    if (meta.added) highlight = meta.added;

    const scroll = body.scrollTop;
    if (!state.items.length) {
      body.innerHTML = emptyHTML();
      foot.innerHTML = '';
      foot.style.display = 'none';
    } else {
      foot.style.display = '';
      const roomLines = state.items.filter(i => byVariant(i.variant_id));
      const lastRoom = roomLines.length ? roomLines[roomLines.length - 1].key : null;
      body.innerHTML = `
        ${progressHTML(t, justSet)}
        <ul class="lines">${state.items.map(i => lineHTML(i, t, i.key === lastRoom)).join('')}</ul>
        ${xsellHTML(state)}
        ${summaryHTML(state, t)}`;
      foot.innerHTML = footHTML(state);
      // Auswahlfelder (Duft-Vorschlag, Geschenk-Sorte) mit Farbpunkt wie auf den Produktseiten
      if (window.ZYXDots) body.querySelectorAll('[data-upsell-scent], [data-gift-swap]').forEach(s => window.ZYXDots.enhance(s));
      // „Passt dazu“: Pfeile nur zeigen, wenn es etwas zu wischen gibt, und am Ende abschalten
      const tr = body.querySelector('.xsell__track'), nav = body.querySelector('.xsell__nav');
      if (tr && nav) {
        const upd = () => {
          const max = tr.scrollWidth - tr.clientWidth;
          nav.hidden = max <= 4;
          nav.children[0].disabled = tr.scrollLeft <= 4;
          nav.children[1].disabled = tr.scrollLeft >= max - 4;
        };
        tr.addEventListener('scroll', upd, { passive: true });
        requestAnimationFrame(upd);
      }
      if (!meta.opening) body.scrollTop = scroll;
    }
    if (justSet.size && isOpen) {
      const th = D.thresholds.find(x => justSet.has(x.key) && x.key !== 'shipping') || D.thresholds.find(x => justSet.has(x.key));
      site.toast(`Freigeschaltet: ${th.label}`);
    }
    const fill = body.querySelector('.progress__fill');
    if (fill && root.dataset.p) {
      const to = fill.style.transform;
      fill.style.transition = 'none';
      fill.style.transform = `scaleX(${root.dataset.p})`;
      void fill.offsetWidth;
      fill.style.transition = '';
      fill.style.transform = to;
    }
    root.dataset.p = MAX() ? Math.min(t.total / MAX(), 1) : 0;
    highlight = [];
  }

  /* ---------- Interaktion ---------- */
  async function run(fn, okMsg) {
    if (busy) return;
    busy = true;
    root.classList.add('is-busy');
    try { await fn(); if (okMsg) site.toast(okMsg); }
    catch (err) { site.toast(err.message || 'Das hat leider nicht geklappt.'); }
    finally { busy = false; root.classList.remove('is-busy'); }
  }

  function onClick(e) {
    const b = e.target.closest('button, a, [data-cart-close]');
    if (!b) return;
    if (b.matches('[data-cart-close]')) { close(); return; }
    if (b.dataset.qty) { run(() => S.setQty(b.dataset.qty, parseInt(b.dataset.to, 10))); return; }
    if (b.dataset.remove) { run(() => S.remove(b.dataset.remove)); return; }
    if (b.dataset.codeRemove) {
      const rest = (S.state.discount_codes || []).map(c => c.code).filter(c => c !== b.dataset.codeRemove);
      run(() => S.setCodes(rest), 'Rabattcode entfernt');
      return;
    }
    if (b.hasAttribute('data-upsell')) {
      const sel = b.closest('.upsell').querySelector('[data-upsell-scent]');
      const s = D.scent(sel ? sel.value : '');
      run(() => S.add([{ id: s && s.variant, quantity: 1 }]), 'Duft hinzugefügt');
      return;
    }
    if (b.dataset.xadd) { run(() => S.add([{ id: Number(b.dataset.xadd), quantity: 1 }])); return; }
    if (b.dataset.xsellDir) {
      const tr = root.querySelector('.xsell__track');
      if (tr) tr.scrollBy({ left: parseInt(b.dataset.xsellDir, 10) * tr.clientWidth * 0.8, behavior: site.reduce ? 'auto' : 'smooth' });
      return;
    }
    if (b.dataset.addSet) {
      const set = D.sets.find(x => x.id === b.dataset.addSet);
      run(() => S.add(set.scents.map(id => ({ id: D.scent(id).variant, quantity: 1 }))));
    }
  }

  // Einheitlicher Weg zum Hinzufügen: Flakon fliegt, Warenkorb öffnet sich mit markierter Zeile
  async function add(items, fromEl, imgSrc) {
    const flight = site.flyToCart(fromEl, imgSrc);
    try {
      const added = await S.add(items);
      await flight;
      open({ highlight: added });
    } catch (err) {
      await flight;
      site.toast(err.message || 'Das hat leider nicht geklappt.');
    }
  }

  mount();
  window.ZYCart = { open, close, add };
})();
